<template>
  <div class="cards row">
    <div
      v-for="f in features"
      :key="f"
      :style="{ height: `${height}` }"
      class="card highlight__extra box__shadow column"
    >
      <div class="icon row center" :style="{ backgroundColor: `rgba(${f.color}, 0.2)` }">
        <i :class="f.icon" :style="{ color: `rgb(${f.color})` }"></i>
      </div>

      <div class="content column">
        <h4>{{ t(f.headline) }}</h4>
        <p>{{ t(f.text) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowCards',
  props: {
    features: { type: Array, default: [] },
    height: { type: String, default: 'auto' },
  },
  setup() {},
}
</script>

<style lang="scss" scoped>
.cards {
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  max-width: 1100px;

  .card {
    padding: 30px;
    border-radius: 15px;
    width: 270px;
    text-align: center;
    margin: 10px;

    &:hover {
      transform: translateY(-5px);
    }

    .icon {
      min-width: 65px;
      max-width: 65px;
      height: 65px;
      min-height: 65px;
      border-radius: 15px;
      margin: 0 auto;
      font-size: 2rem;
    }

    h4 {
      font-size: 1.1rem;
      line-height: 25px;
      width: 100%;
    }

    p {
      margin: 0;
    }
  }
}
</style>
